import React from "react";
import { useLang } from "../context/LanguageContext";

// Canadian flag (for EN — target audience: immigrants to Canada)
const FlagCA = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" aria-hidden="true">
    <rect width="7.5" height="20" fill="#D52B1E"/>
    <rect x="22.5" width="7.5" height="20" fill="#D52B1E"/>
    <rect x="7.5" width="15" height="20" fill="#FFFFFF"/>
    <path d="M15 5.5l0.7 1.8 1.9-0.2-1 1.5 1.6 1.2-1.9 0.3 0.3 1.9-1.6-1L15 12.5l-0.4-1.5-1.6 1 0.3-1.9-1.9-0.3 1.6-1.2-1-1.5 1.9 0.2z" fill="#D52B1E"/>
  </svg>
);

// French flag
const FlagFR = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" aria-hidden="true">
    <rect width="10" height="20" fill="#002395"/>
    <rect x="10" width="10" height="20" fill="#FFFFFF"/>
    <rect x="20" width="10" height="20" fill="#ED2939"/>
  </svg>
);

export default function LanguageToggle({ variant = "light" }) {
  const { lang, toggle } = useLang();
  const isFr = lang === "fr";
  const base = variant === "dark" ? "text-alabaster" : "text-navy";

  return (
    <button
      onClick={toggle}
      aria-label="Toggle language"
      data-testid="language-toggle-button"
      className={`group relative inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-current/20 ${base} text-[11px] font-medium tracking-[0.2em] uppercase transition hover:bg-current/5`}
    >
      <span className={`inline-flex items-center gap-1.5 transition ${isFr ? "opacity-40" : "opacity-100"}`}>
        <FlagCA />
        EN
      </span>
      <span className="opacity-30">/</span>
      <span className={`inline-flex items-center gap-1.5 transition ${isFr ? "opacity-100" : "opacity-40"}`}>
        <FlagFR />
        FR
      </span>
    </button>
  );
}
